import React from 'react';
import { styled } from '@compiled/react';
import { IMAGE_SIZE } from '../constants';

type Props = {
	icon: string;
};

export const TypeIcon = ({ icon }: Props) => (
	<ImageContainer data-testid="software-backlog.card-list.card.card-contents.type-icon.type">
		<Img role="presentation" src={icon} />
	</ImageContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageContainer = styled.div({
	gridColumn: 'issue-type / span 1',
	gridRow: 'card-detail / span 1',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Img = styled.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${IMAGE_SIZE}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${IMAGE_SIZE}px`,
	verticalAlign: 'text-bottom',
});
